import { useCategoriseChecklistItems } from './use-categorise-checklist-items';
import { Checklist, ChecklistItemOverview } from '../../types/checklist';
import ChecklistItemCategorySection from './ChecklistItemCategorySection';
import { useIsActiveSubscription } from '../../hooks/use-is-active-subscription';

type ChecklistItemsTableProps = {
    checklist: Checklist;
    selectedChecklistItems: string[];
    onChecked: (checklistItem: ChecklistItemOverview) => void;
};

function ChecklistItemsTable({ checklist, selectedChecklistItems, onChecked }: ChecklistItemsTableProps): JSX.Element {
    const activeSubscription = useIsActiveSubscription();
    const categoriseItems = useCategoriseChecklistItems(checklist.categories, checklist.checklistItems);

    function handleChecked(id: string): void {
        const selectedChecklistItem = checklist.checklistItems.filter((i) => i.id === id);
        onChecked(selectedChecklistItem[0]);
    }

    return (
        <div className="max-w-[100%] mx-auto">
            {categoriseItems.length === 0 && <p className="block text-center text-sm text-gray-500 pt-4">No checklist items</p>}

            {categoriseItems.map((i, idx) => {
                return (
                    <ChecklistItemCategorySection
                        key={idx}
                        checklistId={checklist.id}
                        categoryDetails={i}
                        isDisabled={!activeSubscription || checklist.system}
                        onChecked={handleChecked}
                        selectedChecklistItems={selectedChecklistItems}
                    />
                );
            })}
        </div>
    );
}

export default ChecklistItemsTable;
